import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import FlexContainer from '../FlexContainer';
const Title = styled.div `
  margin-top: 32px;
  font-size: 18px;
  font-family: 'Roboto Bold';
  color: ${(props) => props.colorTheme};
  text-align: center;
`;
const Content = styled.div `
  width: 100%;
`;
const StyledModal = styled(Modal) `
  width: ${props => props.width}px;
  
  .ant-modal-footer {
    border-top-color: transparent;
  }
`;
const InfoModal = ({ id, okButtonProps = {}, cancelButtonProps = {}, icon, colorTheme, title, children, width = 500, onCancel, closable = false }) => {
    var _a, _b, _c;
    const { t: translate } = useTranslation();
    return (<StyledModal id={id} closable={closable} cancelButtonProps={{
            ...cancelButtonProps,
            name: (_a = cancelButtonProps.name) !== null && _a !== void 0 ? _a : 'CANCEL'
        }} okButtonProps={{
            ...okButtonProps,
            name: (_b = okButtonProps.name) !== null && _b !== void 0 ? _b : 'CONFIRM',
            colorTheme: (_c = okButtonProps.colorTheme) !== null && _c !== void 0 ? _c : colorTheme
        }} width={width} onCancel={onCancel}>
      <FlexContainer>
        {icon}
      </FlexContainer>
      <Title colorTheme={colorTheme}>{translate(title)}</Title>
      <Content>
        {children}
      </Content>
    </StyledModal>);
};
export default InfoModal;
